// フロントエンドロールユーティリティ

import { isEnvIdhInternal } from './env-util-frontend';
import { isRoleAdmin, isRoleAdminOrManager, isRoleManager, isRoleManagerOrGeneral } from '@/class/common/util/role_util';

/**
 * ダッシュボードを閲覧できる権限か？
 * @returns
 */
export function isRoleExternalAdminOrManager(role: number): boolean {
  if ( isEnvIdhInternal() ) {
    // IDH社内専用処理
    // 労務管理者のみ閲覧可能
    return isRoleManager( role );
  } else {
    // 社外用処理
    // アカウント管理者と労務管理者のみ閲覧可能
    return isRoleAdminOrManager(role);
  }
}

/**
 * 勤怠登録を閲覧できる権限か？
 * @param role 権限
 * @returns true: 表示する。
 */
export function isRoleWithoutInternalAdmin(role: number): boolean {
  // IDH社内の場合はアカウント管理者はアクセス不可
  return !isEnvIdhInternal() || isRoleManagerOrGeneral( role );
}

/**
 * 労務管理者選択ボックス（ユーザー管理画面など）にアカウント管理者を表示するか？
 * @returns true: 表示する。
 */
export function isRoleShowAdminInLaborManagerSelectBox(role: number): boolean {
  if ( isEnvIdhInternal() ) {
    // IDH社内専用処理
    // アカウント管理者以外でログイン中は「アカウント管理者」を労務管理者選択ボックスに表示。
    return !isRoleAdmin( role );
  } else {
    // 社外用処理
    // 常に「アカウント管理者」を労務管理者選択ボックスに表示。
    return true;
  }
}
